import { useAppContext } from 'components/common/AppProvider';
import { SgIcon } from 'components/common/Icons/SG';
import React, { useEffect } from 'react';
import { NavLink } from 'react-router';
import { RoutePaths } from 'routes/RoutePaths';
import { track, TrackedPageType } from 'services/Logger';
import { getAppContext } from 'store/AppContext/AppContextThunk';

export const HeaderLogo = () => {
    const { dispatch } = useAppContext();

    useEffect(() => {
        dispatch(getAppContext()).catch(() => void 0);
    }, []);

    const handleClick = () => {
        track('ClickOnMenu', 'click on menu', { page: TrackedPageType.Menu, pageName: 'Home' });
    };

    return <NavLink
        end
        to={RoutePaths.Home.url()}
        className="navbar-title-link"
        onMouseUp={() => handleClick()}
    >
        <SgIcon />
        <div className="navbar-title-divider" />
        <div className="navbar-service-name">FRANFINANCE ENTREPRISES</div>
    </NavLink>;
};
